import React, { useState, useRef } from "react";
import { useSelector } from "react-redux";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import ScrollToTop from "../../components/Common/ScrollTop";
import Loader from "../../Loader";
import { BASE_URL, REACT_APP_RECAPTCHA_SITE_KEY } from "../../Service";
import GoogleMapSection from "../../components/GoogleMapSection/GoogleMapSection";
import ReCAPTCHA from "react-google-recaptcha";

const ContactMain = () => {
  const siteData = useSelector(
    (state) => state.data.sitesetting?.siteSetting?.[0]?.data
  );
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    website: "",
    message: "",
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const { page } = useSelector((state) => state.data);
  const [formErrors, setFormErrors] = useState({});

  if (!page || !page.data) {
    return <Loader />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, email, phone, message } = formData;
    const errors = {};

    if (!name.trim()) errors.name = "Name is required";
    if (!email.trim()) {
      errors.email = "Email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        errors.email = "Invalid email format";
      }
    }

    if (!phone.trim()) {
      errors.phone = "Phone number is required";
    } else if (phone.length < 7 || phone.length > 15) {
      errors.phone = "Phone number must be 7 to 15 characters long.";
    } else {
      const phoneRegex = /^[\d+-]{7,15}$/;
      if (!phoneRegex.test(phone)) {
        errors.phone = "Invalid  phone number";
      }
    }

    if (!message.trim()) errors.message = "Message is required";

    if (!captchaToken) {
      alert("Please complete the CAPTCHA verification to proceed.");
    }

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    setError(null);
    setSuccess(false);

    try {
      const json = { name, email, phone, message };
      if (formData.website && formData.website.length > 0) {
        json.website = formData.website;
      }
      const payload = {
        data: {
          ...json,
          captchaToken: captchaToken,
        },
      };

      const res = await fetch(`${BASE_URL}/api/v1/form`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          domain: "techniajz.com",
        },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const errBody = await res.text();
        throw new Error(errBody || res.statusText);
      }

      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);

      setFormData({ name: "", email: "", phone: "", website: "", message: "" });
      setCaptchaToken(null);
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
    }
  };

  return (
    <React.Fragment>
      <SiteBreadcrumb pageTitle="Contact Us" pageName="Contact" />

      {/* Contact Section Start */}
      <div className="rs-contact pt-120 md-pt-80">
        <div className="container">
          <div className="row">
            {/* Contact Info */}
            <div className="col-lg-4 md-mb-60">
              <div className="contact-box">
                <div className="sec-title mb-44">
                  <div className="sub-text new-text white-color"></div>
                  <div className="title white-color">Let's Talk With Us!</div>
                </div>
                <div className="address-box mb-24">
                  <div className="address-icon">
                    <i className="fa fa-phone"></i>
                  </div>
                  <div className="address-text">
                    <span className="label">Phone:</span>
                    <a href="tel:9654652847">{siteData.phones}</a>
                  </div>
                </div>
                <div className="address-box mb-24">
                  <div className="address-icon">
                    <i className="fa fa-home"></i>
                  </div>
                  <div className="address-text">
                    <span className="label">Email:</span>
                    <a
                      href="https://mail.google.com/mail/?view=cm&amp;fs=1&amp;to=info@techniajz.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {siteData.email}
                    </a>
                  </div>
                </div>
                <div className="address-box">
                  <div className="address-icon">
                    <i className="fa fa-map-marker"></i>
                  </div>
                  <div className="address-text">
                    <span className="label">Address:</span>
                    <div className="desc">{siteData.addresses}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-lg-8 pl-70 md-pl-14 centerText">
              <div className="contact-widget">
                <div className="sec-title2 mb-40">
                  <div className="sub-text contact mb-14">Get In Touch</div>
                  {/* <div className="title testi-title">Fill The Form Below</div> */}
                </div>
                {error && (
                  <div style={{ color: "red", marginBottom: "10px" }}>
                    {error}
                  </div>
                )}
                {success && (
                  <div
                    style={{
                      color: "green",
                      marginBottom: "10px",
                      fontWeight: "600",
                    }}
                  >
                    Thanks for reaching out — we’ll be in touch soon!
                  </div>
                )}
                <form id="contact-form" action="#">
                  <div className="row">
                    <div className="col-md-6 mb-30">
                      <input
                        className="from-control"
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Name"
                        required
                        value={formData.name}
                        onChange={(e) =>
                          setFormData({ ...formData, name: e.target.value })
                        }
                      />
                      {formErrors.name && (
                        <div style={{ color: "red", fontSize: "14px" }}>
                          {formErrors.name}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 mb-30">
                      <input
                        className="from-control"
                        type="email"
                        id="email"
                        name="email"
                        placeholder="E-Mail"
                        required
                        value={formData.email}
                        onChange={(e) =>
                          setFormData({ ...formData, email: e.target.value })
                        }
                      />
                      {formErrors.email && (
                        <div style={{ color: "red", fontSize: "14px" }}>
                          {formErrors.email}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 mb-30">
                      <input
                        className="from-control"
                        type="tel"
                        id="phone"
                        name="phone"
                        placeholder="Phone Number"
                        required
                        value={formData.phone}
                        // onChange={(e) =>
                        //   setFormData({ ...formData, phone: e.target.value })
                        // }
                        onChange={(e) => {
                          const updatedPhone = e.target.value.replace(
                            /[^0-9+-]/g,
                            ""
                          );
                          if (updatedPhone.length <= 15) {
                            setFormData({ ...formData, phone: updatedPhone });
                          }
                        }}
                      />
                      {formErrors.phone && (
                        <div style={{ color: "red", fontSize: "14px" }}>
                          {formErrors.phone}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 mb-30">
                      <input
                        className="from-control"
                        type="url"
                        id="website"
                        name="website"
                        placeholder="Your Website"
                        value={formData.website}
                        onChange={(e) =>
                          setFormData({ ...formData, website: e.target.value })
                        }
                      />
                    </div>
                    <div className="col-12 mb-30">
                      <textarea
                        className="from-control"
                        id="message"
                        name="message"
                        placeholder="Your message Here"
                        required
                        value={formData.message}
                        onChange={(e) =>
                          setFormData({ ...formData, message: e.target.value })
                        }
                      />
                      {formErrors.message && (
                        <div style={{ color: "red", fontSize: "14px" }}>
                          {formErrors.message}
                        </div>
                      )}
                    </div>
                    {/*  Google reCAPTCHA */}
                    <div className="col-12 mb-30 mt-20 reCaptcha">
                      <ReCAPTCHA
                        sitekey={REACT_APP_RECAPTCHA_SITE_KEY}
                        onChange={(token) => setCaptchaToken(token)}
                        onExpired={() => setCaptchaToken(null)}
                        ref={recaptchaRef}
                      />
                      {formErrors.recaptcha && (
                        <div style={{ color: "red", fontSize: "14px" }}>
                          {formErrors.recaptcha}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="btn-part">
                    <button
                      className="readon learn-more submit"
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Submit Now
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Map */}
      <div className="map-canvas pt-120 md-pt-80">
        <GoogleMapSection />
      </div>

      {/* ScrollToTop */}
      <ScrollToTop />
    </React.Fragment>
  );
};

export default ContactMain;
